import { ALREADY_ANSWERED, INFO_KUBUN, MEDICAL_RECORDS, UNANSWERED } from '../constants/constants';
import { MedicalHealthInformationData } from '../types/MedicalHealthInformation';
import { Status } from '../types/Status';

export const parseDate = (date: string) => {
  if (!date || date.length !== 8) {
    return '';
  }
  const year = date.substring(0, 4);
  const month = date.substring(4, 6);
  const day = date.substring(6, 8);
  return `${year}/${month}/${day}`;
};

export const parseTime = (time: string) => {
  if (!time || time.length !== 4) {
    return '';
  }
  const hour = time.substring(0, 2);
  const minute = time.substring(2, 4);
  return `${hour}:${minute}`;
};

/**
 * QuestionnaireResponseのステータスをパース
 */
export const parseQuestionnaireResponseStatus = (informationKbn: string, completeFlag: string): Status => {
  if (informationKbn === INFO_KUBUN.PRACTITIONER) {
    return MEDICAL_RECORDS;
  }
  return completeFlag === '1' ? ALREADY_ANSWERED : UNANSWERED;
};

/**
 * 医療健康情報のステータスをパース
 */
export const parseMedicalInformationStatus = (data: MedicalHealthInformationData): Status | null => {
  // 事前問診かつ未完了であれば未回答を返す。それ以外は何も返さない
  return data.questionnaire_response_list.some(
    (item) => item.information_kbn === INFO_KUBUN.PATIENT && item.complete_flag === '0'
  )
    ? UNANSWERED
    : null;
};

/**
 * 回答状況のステータスをパース
 */
export const parseCompleteStatus = (completeFlag: string): Status => {
  return completeFlag === '1' ? ALREADY_ANSWERED : UNANSWERED;
};
